import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoacheeProfileDocumentsController } from 'presentation/page/profile/coachee-profile/coachee-profile-documents/coachee-profile-documents.controller';

@Component({
	selector: 'spr-coachee-profile-documents-filter',
	templateUrl: './coachee-profile-documents-filter.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'flex md:flex-none md:items-center bg-grey-alabaster p-3 md:space-x-3 md:flex-row flex-col md:space-y-0 space-y-3',
	},
})
export class CoacheeProfileDocumentsFilterComponent {
	constructor(public controller: CoacheeProfileDocumentsController) {}

	public onDateSortClick() {
		this.controller.toggleDateSort();
	}
}
